/**
 * Destroyable
 */
export interface Destroyable {
    /**
     * destroy
     */
    destroy(): void;
}
